import { AppRegistry } from 'react-native';
import App from './App.web';
import { name as appName } from './app.json';

AppRegistry.registerComponent(appName, () => App);

const rootTag = document.getElementById('root');
AppRegistry.runApplication(appName, { rootTag });
